import {Component, inject, input} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {SvgIconComponent} from 'angular-svg-icon';
import {FilterService} from './filter.service';

@Component({
    selector: 'app-search-input',
    standalone: true,
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.scss',
    imports: [
        SvgIconComponent,
        FormsModule,
        TranslateModule,
        MatInputModule,
        ReactiveFormsModule
    ]
})
export class SearchInputComponent
{
    public readonly control = input<FormControl>();

    public filter: string;

    private readonly filterService = inject(FilterService);

    public constructor()
    {
        this.filterService.onFilterChanged().pipe(takeUntilDestroyed()).subscribe((value: string) => this.filter = value);
    }

    public filterData(): void
    {
        this.filterService.changeFilter(this.filter);
    }
}
